import type { ButtonProps } from 'antd';
import { Button } from 'antd';
import { useAccess } from '@umijs/max';
import React from 'react';

type Props = ButtonProps & {
  permission_code?: string;
  permissionCode?: string;
};

const AuthButton: React.FC<Props> = ({ permission_code, permissionCode, ...props }) => {
  const access = useAccess();
  const code = permissionCode ?? permission_code;
  const allowed = !code || access?.hasPermission?.(code);
  if (!allowed) return null;

  if (code) {
    return <Button {...props} data-permission-code={code} />;
  }
  return <Button {...props} />;
};

export default AuthButton;
